import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Container } from 'reactstrap';
import ListSearch from './listSearch';
import ListResult from './listResult';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { listRequest as listRequestAction, listClear as listClearAction} from '../../store/concentrations/actions'
import { getConcentrations } from '../../store/concentrations/selectors';
import queryString from 'query-string'
import { Button, Col, Row, Spinner,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label } from 'reactstrap';

interface IState {
    term : string
    sorting : string
    offset: number
    limit: number
}

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    ui : any
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction
    listClear : typeof listClearAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class ConcentrationMainPage extends React.Component<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        let limit = this.props.ui?.searchParams?.limit ?? 10;
        if (limit === 1) limit = 10;
        this.state = {
            term : this.props.ui?.searchParams?.term ?? '',
            sorting: this.props.ui?.searchParams?.sorting ?? '',
            offset : this.props.ui?.searchParams?.offset ?? 0,
            limit: limit
        };
    }

    public componentDidMount() {
        const parsed = queryString.parse(this.props.route.location.search);
        const { searchParams: stateSP } = this.props.ui;
       
        var sTerm = '';
        var sSorting = '';
        if (parsed.term) sTerm = parsed.term.toString();
        if (parsed.sorting) sSorting = parsed?.sorting.toString();

        // Compare if different only query again
        let isNewSearch = true;
        if ((stateSP != undefined) && (
            stateSP.term === sTerm && 
            stateSP.sorting === sSorting &&
            stateSP.offset === this.state.offset && 
            stateSP.limit === this.state.limit 
            )){
            isNewSearch = false;
        }

        if (isNewSearch){
            this.setState({
                term : sTerm, 
                sorting: sSorting
            }, () => {
                this.ListRequest();
            });
        }
    }

    componentDidUpdate(prevProps: AllProps) {
    }
    
    public componentWillUnmount() {
    } 
   
    private Search(d:any) { 
        this.setState({offset : 0, 
            term : d?.term??"".toLowerCase()
        }, () => {
                this.props.route.history.push('?term=' + d.term + '&sorting=' + this.state.sorting );
                this.ListRequest();
        });
    }
    private LoadMore(d:any) { 
        this.setState({offset : this.state.offset +  this.state.limit}, () => {
            this.ListRequest();
        }); 
    }
    private Sorting(d:any) { 
        this.setState({offset : 0, sorting : d.searchSorting}, () => {
            this.props.route.history.push('?term=' + this.state.term + '&sorting=' + this.state.sorting );
            this.ListRequest();
        }); 
    }
    private ListRequest(){
        var searchParams:any = {};
        searchParams["term"] = this.state.term;
        searchParams["sorting"] = this.state.sorting;
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        this.props.listRequest(searchParams);
    }

    public render() {
        const { ui } = this.props.ui;
        return (
            <Container className="bg-light">
                <ListSearch 
                    onSearch={this.Search.bind(this)} 
                    term={this.state.term} 
                    loading={this.props.ui.loading} />
                <br />
                <RouterNavLink to={"/concentrations/new"}><Button color="success"><i className="fas fa-plus mr-1"></i>Add New</Button></RouterNavLink>
                <ListResult 
                    onLoadMore={this.LoadMore.bind(this)} 
                    onSorting={this.Sorting.bind(this)} 
                    term={this.state.term} 
                    sorting={this.state.sorting}
                    data={this.props.data} 
                    loading={this.props.ui.loading} 
                    totalDocument={this.props.ui.totDoc} 
                    offset={this.state.offset} limit={this.state.limit}  />
            </Container>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.concentration.ui,
    data: getConcentrations(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction,
    listClear : listClearAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConcentrationMainPage)
